import React from 'react'
import Navbar from '../components/Navbar'
import SevenYearModel from '../components/SevenYearModel'

const CallForAgricOffice = () => {
  return (
    <>
    <Navbar />

    <div className='bg-light py-5'>
        <h2>Call for Agric Officer / Site Officer</h2>
        <ul>
            <li>Supervising field staff and ensuring that all operations are running effectively and according to plan</li>
            <li>Report Farm Manager on all key activities and next action to take.</li>
            <li>Proper record keeping</li>
            <li>Effective communication</li>
            <li>Responsible for looking for market for produce cultivated</li>
            <li>All other activities for the effective and smooth running of the farm site</li>
        </ul>
    </div>

    </>
  )
}

export default CallForAgricOffice